import cartsApi from '@/api/cartsApi'
const state: any = {
  cartsAmount: 0
}

const getters = {

}

const mutations = {
  changeCartsAmount(state: any, num: number) {
    state.cartsAmount = num
  }
}

const actions = {
  getCartList(state: any) {
    cartsApi.getCartsList({
    }).then((res) => {
      if (res.code === 200) {
        let cartsLenth = res.data.length
      //  
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
